import React from "react";
import classes from "./FormTitle.module.scss";

const FormTitle = (props) => (
  <>
    <div className={classes.FormTitle} style={props.style}>
      {props.title}
    {props.subTitle && <h4 className={classes.subTitle}>{props.subTitle}</h4>}
    </div>
  </>
);

export default FormTitle;
